// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchWithinStyles } from "@bg/Overrides/Widgets/ProductList/ProductListSearchWithin";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

searchWithinStyles.searchTextField = {
    iconProps: {
        src: "Search",
    },
    cssOverrides: {
        formField: css`
            width: 100%;
            > div {
                margin-top: 0 !important;

                button {
                    position: absolute;
                    left: 0;
                    span {
                        padding: 0 !important;
                        right: auto !important;
                        top: auto !important;
                    }
                    svg {
                        color: ${getColor("tertiary")};
                        width: 20px;
                        height: 20px;
                    }
                }
                input {
                    padding-left: 40px !important;
                }
            }
        `,
    },
};
